<div class="edit-service-container">


<div class="page-header">

<h1>
Edit Service
</h1>

<p>
Update your service details
</p>
</div>





<div class="edit-card">


<form
[formGroup]="serviceForm"
(ngSubmit)="updateService()">






<!-- MEDIA -->

<div class="form-group">


<label>
Service Profile Pic
</label>


<input
type="file"
accept="image/*"
(change)="selectFiles($event)">



</div>





<div
class="preview-grid"
*ngIf="previewFiles.length">


<div
class="preview-item"
*ngFor="let file of previewFiles;let i=index">


<img
*ngIf="file.type==='image'"
[src]="file.url">


<video
*ngIf="file.type==='video'"
[src]="file.url"
controls>
</video>


<button
type="button"
(click)="removeFile(i)">
×
</button>


</div>


</div>










<div class="form-group">

<label>
Service Name
</label>


<input
type="text"
formControlName="service_name">

</div>








<div class="form-group">

<label>
Category
</label>

<select formControlName="category">


<option value="">
Select Category
</option>


<option
*ngFor="let category of categories"
[value]="category._id">

{{category.name}}

</option>


</select>


</div>










<div class="form-group">

<label>
Description
</label>


<textarea
formControlName="description">
</textarea>


</div>







<div class="form-group">

<label>
Price
</label>


<input
type="number"
formControlName="price">


</div>









<div class="form-group">

<label>
Duration
</label>


<input
type="text"
formControlName="duration">


</div>







<div class="form-group">

<label>
Included
</label>


<textarea
formControlName="included">
</textarea>


</div>









<!-- LOCATION -->


<div class="location-section">


<h3>
Available Locations
</h3>



<div class="location-input">


<input
type="text"
placeholder="Enter location"

[(ngModel)]="locationInput"

[ngModelOptions]="{standalone:true}"

>


<button
type="button"
(click)="addLocation()">

Add

</button>


</div>





<div class="chips">


<span
*ngFor="let loc of locations;let i=index">


{{loc}}


<button
type="button"
(click)="removeLocation(i)">
×
</button>


</span>


</div>


</div>









<!-- PAYMENT -->


<div class="payment-section">


<h3>
Payment Preference
</h3>



<select

[(ngModel)]="paymentType"

[ngModelOptions]="{standalone:true}"

(change)="paymentChanged()">


<option value="FULL_PAYMENT">
Full Payment
</option>


<option value="ADVANCE">
Advance
</option>


<option value="POSTPAID">
Postpaid
</option>


<option value="CASH_ON_HAND">
Cash On Hand
</option>


</select>






<input

*ngIf="paymentType==='ADVANCE'"

type="number"

placeholder="Advance Amount"

[(ngModel)]="advanceAmount"

[ngModelOptions]="{standalone:true}"

>


</div>









<div class="button-group">


<button
class="update-btn">

Update Service

</button>



<button
type="button"

class="cancel-btn"

(click)="goBack()">

Cancel

</button>


</div>






</form>


</div>


</div>